import React from 'react';
import './index.scss';

export const IconLightning: React.FC = () => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    className="icon-lightning"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3125 20.7188L20.7188 3.65625V18.2812H29.25L15.8438 35.3438V20.7188H7.3125Z"
      stroke="#15141D"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
